<div class="col-md-12 attachment">

  <div class="title-attachment">
    {{label | translate}}
    @if (currentFile) {
      <div class="download-buttons" (click)="downloadFile()" #tooltip="matTooltip"
        matTooltip="{{'BUTTONS.DOWNLOAD' | translate}}">
        <mat-icon [ngStyle]="{'color': currentFile ? 'green' : ''}">download</mat-icon>
      </div>
    }

    @if (!edit) {
      <div class="download-buttons" #tooltip="matTooltip" matTooltip="{{'LABELS.EDIT' | translate}}"
        (click)="toggleEdit()">
        <mat-icon>attachment</mat-icon>
      </div>
    }

    @if (edit) {
      <div class="download-buttons" #tooltip="matTooltip"
        matTooltip="{{'BUTTONS.CLOSE' | translate}} edicion de Archivo" (click)="toggleEdit()">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#797882">
          <path d="M0 0h24v24H0V0z" fill="none" />
          <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />
        </svg>
      </div>
    }
  </div>

  @if (edit) {
    <label for="{{id}}" class="attachment-label">
      <div class="input-attachment">
        <div class="name-attachment">{{file_name}}</div>
        <div class="img-attachment">
          <mat-icon>attach_file</mat-icon>
        </div>
      </div>
    </label>
  }
  <input class="form-control" id="{{id}}" class="attachment" type="file" (change)="upload_attachment($event)" />
</div>